import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import EstadosServices from "./estados_services";

export const getEstados = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_ESTADOS,
      payload: true,
    });
    const resp = await EstadosServices.getEstados(filters);
    // console.clear();
    // console.log('RESPONSE => ', resp.data);
    dispatch({
      type: actions.GET_ESTADOS,
      payload: resp.data, // agregar .data
    });
    dispatch({
      type: actions.ESTADOS_FALLA,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.ESTADOS_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_ESTADOS,
      payload: false,
    });
  }
}

export const deleteEstado = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_ESTADOS,
      payload: true,
    });
    await EstadosServices.deleteEstado(id);
    const { data, count } = getState().estados.estados;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_ESTADOS,
      payload: {
        data: _data,
        count: count - 1
      },
    });
    dispatch({
      type: actions.ESTADOS_FALLA,
      payload: '',
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.ESTADOS_FALLA,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADER_ESTADOS,
      payload: false,
    });
  }
}

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const editestado = (req, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_ESTADOS,
      payload: true,
    });
    const resp = await EstadosServices.editestado(req.id, req);
    const { data, count } = getState().estados.estados;
    let _data = data.slice();
    _data[index] = resp.data;
    dispatch({
      type: actions.GET_ESTADOS,
      payload: {
        data: _data,
        count: count,
      },
    });
    dispatch({
      type: actions.FORM_ESTADOS_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_ESTADOS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_ESTADOS,
      payload: false,
    });
  }
}

export const saveEstados = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_ESTADOS,
      payload: true,
    });
    const resp = await EstadosServices.saveEstado(req);
    const { data, count } = getState().estados.estados;
    dispatch({
      type: actions.GET_ESTADOS,
      payload: {
        count: count + 1,
        data: [...data, resp.data]
      },
    });
    dispatch({
      type: actions.FORM_ESTADOS_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = ex.response.data[0];
            }
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_ESTADOS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_ESTADOS,
      payload: false,
    });
  }
};
